import { Component, EventEmitter, Input, Output } from '@angular/core';

import {
  blankInviteExpiry,
  InviteExpiry,
  InviteExpiryMode,
  inviteExpiryValidationError
} from '../../../../../models/invite-expiry';


/** The "how long does the participant have to accept" question of the invite modals (PRO-1537). */
@Component({
  selector: 'app-invite-expiry-input',
  templateUrl: './invite-expiry-input.component.html',
})
export class InviteExpiryInputComponent {
  public readonly InviteExpiryMode = InviteExpiryMode;

  @Input() idPrefix: string;
  @Input() timeZone: string | null = null;
  @Input() disabled = false;

  @Input() expiry: InviteExpiry = blankInviteExpiry();
  @Output() expiryChange = new EventEmitter<InviteExpiry>();

  public update(changes: Partial<InviteExpiry>) {
    // Kept locally too: the date picker can emit a date and a time in one
    // tick, before the parent's binding flows back in.
    this.expiry = { ...this.expiry, ...changes };
    this.expiryChange.emit(this.expiry);
  }

  public validationError(): string | null {
    return inviteExpiryValidationError(this.expiry, this.timeZone);
  }
}
